if (document.querySelectorAll(".card-story").length > 1) {
  const storyCardsUi = {
    storyCards: {
      parent: document.querySelectorAll(".card-story"),
      child: document.querySelectorAll(".card-story"),
    },
  }

  const storyCardsData = {
    biggestHeight: 0,
    windowWidth: window.innerWidth,
  }

  window.addEventListener("load", (event) => {
    if (storyCardsData.windowWidth > 768) {
      setBiggestHeight(storyCardsUi.storyCards)
    }
  })

  const setBiggestHeight = (parentName) => {
    storyCardsData.biggestHeight = 0

    if (parentName.parent) {
      parentName.child.forEach((item) => {
        const currentHeight = item.scrollHeight

        if (currentHeight > storyCardsData.biggestHeight) storyCardsData.biggestHeight = currentHeight
      })
    }

    setAdaptiveHeight(parentName, storyCardsData.biggestHeight)
  }

  const setAdaptiveHeight = (parentName, biggestHeight) => {
    parentName.child.forEach((item) => {
      item.style.minHeight = `${biggestHeight}px`
    })
  }
}
